$(function () {
    'use-strict';

    let $picker = null;
    let $galleryModal = $('#gallery-modal');
    let $modalContent = $galleryModal.find('.modal-body .content')
    let url = $galleryModal.find('form').attr('action');
    let $gameOptionsWrapper = $('#game-options .card-body');
    let $memoCardsWrappers = $('.memo-cards-wrapper');
    let $gameOptions = {};
    let $gameImgTmpl = $('#game-img-tmpl');
    let $memoCardTmpl = $('#group-memo-card-pair-tmpl');
    let differentMemoCardsMin = 5;

    $gameImgTmpl.attr('id', '').removeClass('hidden').remove();
    $memoCardTmpl.attr('id', '').removeClass('hidden').remove();

    function openImagePicker(e) {
        e.preventDefault();
        $picker = $(e.currentTarget);

        $galleryModal.modal('show');
    }

    function pickImage(e) {
        e.preventDefault();
        let $cardImg = $(e.currentTarget).closest('.card-img');

        let $inputImgId = $picker.find('input.img-id');
        $inputImgId.val($cardImg.data('id'));

        let $inputImgTitle = $picker.find('input.img-title');
        $inputImgTitle.val($cardImg.data('title'));

        let $inputImgThumb = $picker.find('input.img-thumb');
        $inputImgThumb.val($cardImg.data('thumb-url'));

        let $inputFileUrl = $picker.find('input.file-url');
        $inputFileUrl.val($cardImg.data('file-url'));

        // Remove input type="file" once it is not possible to update it.
        let $inputImgFilename = $picker.find('input.img-filename');
        $inputImgFilename.remove();

        let $img = $picker.find('img.img-thumb');
        $img.attr('src', $cardImg.data('thumb-url')).removeClass('hidden');

        let $imagePickerInfo = $picker.find('.image-picker-info');
        $imagePickerInfo.remove();
    }

    function removeImage($el) {
        $el.remove();
    }

    function getGameTemplate() {
        let gameTemplate = $('[name="game_template"]').val();

        return gameTemplate;
    }

    function updateGameSpecificContent(gameTemplate) {
        let gameTemplates = ['wheel-of-fortune', 'memo'];

        // Hide all game template specific content.
        gameTemplates.forEach((template) => {
            $('.' + template + '-show').addClass('hidden');
        });

        // Show game template specific content.
        $('.' + gameTemplate + '-show').removeClass('hidden');
    }

    function updatePrizesRow(gameTemplate, change) {
        if (change) {
            // Remove all prizes.
            $('#prizes .row-prize').each((index, el) => {
                let $el = $(el);
                $el.find('.btn.remove-prize').trigger('click');
            });

            // Add a new prize row.
            $('#add-prize').trigger('click');
        }

        if (gameTemplate === 'memo') {
            // Setup the default prize for memo game.
            let $rowPrize = $('#prizes .row-prize:first');

            $rowPrize.find('.p-title').val('Default');
            $rowPrize.find('.p-consolation').attr('checked', true);
            $rowPrize.find('.image-picker').empty();
            $rowPrize.hide();
        }
    }

    function updateGameOptions(gameTemplate) {
        $gameOptionsWrapper.children().each(function(index, el) {
            let $el = $(el);
            $el.removeClass('hidden').remove();
            $gameOptions[$el.data('game-template')] = $el;
        });

        $gameOptionsWrapper.empty().append($gameOptions[gameTemplate]);

        if (gameTemplate === 'memo') {
            $('.memo-different-images').on('input', (e) => {
                updateGameOptionsMemo();
            });

            $('#add-memo-card').on('click', (e) => {
                cloneMemoCardGroup();
            });
        }

        updateGameOptionsMemo();
    }

    function updateGameOptionsMemo() {
        let $el = $('.memo-different-images:checked');
        let differentImages = $el.val() === '1';

        $('[data-memo-different-images]').addClass('hidden');
        $('[data-memo-different-images="' + String(differentImages) + '"]').removeClass('hidden');

        let $wrapperSameImages = $memoCardsWrappers.filter((index, el) => {
            return $(el).data('different-images') === false;
        });

        let $wrapperDifferentImages = $memoCardsWrappers.filter((index, el) => {
            return $(el).data('different-images') === true;
        });

        let $wrapper = null;
        let $parent = $wrapperSameImages.parent().length ? $wrapperSameImages.parent() : $wrapperDifferentImages.parent();

        if (!differentImages) {
            $wrapperDifferentImages.remove();
            $wrapper = $wrapperSameImages;
        } else {
            $wrapperSameImages.remove();
            $wrapper = $wrapperDifferentImages;
        }

        if (!$wrapper.parent().length) {
            $parent.append($wrapper);
        }

        updateMemoCardsWrapper($wrapper, differentImages);
    }

    function updateMemoCardsWrapper($wrapper, differentImages) {
        if (!differentImages) {
            updateMemoCardImagePickers($wrapper);
        } else {
            updateMemoCardIndexes($wrapper);
        }
    }

    function updateMemoCardIndexes($wrapper) {
        $wrapper.find('.group-memo-card-pair').each((cardIndex, card) => {
            $(card).find('.image-picker-wrapper').children().each((imgPickerIndex, imgPicker) => {
                $(imgPicker).find('input').each((index, el) => {
                    let $el = $(el);
                    let name = $el.prop('name');

                    // Set the correct indexes to the arrays (prop name).
                    name = name.replace(/^(.*)(\[\d+\])(\[\d+\])(.*)$/, '$1[' + (cardIndex) + '][' + (imgPickerIndex) + ']$4');
                    $el.prop('name', name);
                });
            });
        });
    }

    function updateMemoCardImagePickers($wrapper) {
        updateMemoCardImageIndexes($wrapper);
        updateImageRequired($wrapper);
    }

    function updateMemoCardImageIndexes($wrapper) {
        $wrapper.find('.image-picker-wrapper').each((imgPickerIndex, imgPicker) => {
            $(imgPicker).find('input').each((index, el) => {
                let $el = $(el);
                let name = $el.prop('name');

                // Set the correct indexes to the arrays (prop name).
                name = name.replace(/^(.*)(\[\d+\])(.*)$/, '$1[' + (imgPickerIndex) + ']$3');
                $el.prop('name', name);
            });
        });
    }

    function updateImageRequired($row) {
        // Let the image picker only be required if its the only element in the row
        if ($row.find('.image-picker-wrapper').length === 1) {
            $row.find('.image-picker-wrapper').first().find('input').prop('required', true);
        } else if ($row.find('.image-picker-wrapper').length <= 5) {
            $row.find('.image-picker-wrapper').last().find('input').prop('required', true);
        } else {
            $row.find('.image-picker-wrapper').last().find('input').prop('required', false);
        }
    }

    function cloneMemoCardGroup() {
        let $wrapper = $('.memo-cards-wrapper[data-different-images="true"]');
        let $clone = $memoCardTmpl.clone();

        $wrapper.append($clone);
        updateMemoCardIndexes($wrapper);
    }

    function cloneImgPicker() {
        let $wrapper = $picker.closest('.memo-cards-wrapper .image-picker-wrapper').parent();

        if ($wrapper.last().find('.img-thumb.hidden').length || $wrapper.data('different-images')) {
            return;
        }

        let $clone = $gameImgTmpl.clone();
        $wrapper.append($clone);
        updateMemoCardImagePickers($wrapper);
    }

    function init() {
        let gameTemplate = getGameTemplate();

        if (gameTemplate) {
            updatePrizesRow(gameTemplate, false);
            updateGameOptions(gameTemplate);
            updateGameSpecificContent(gameTemplate);
        }
    }

    $('[name="game_template"]').on('change', () => {
        let gameTemplate = getGameTemplate();

        updatePrizesRow(gameTemplate, true);
        updateGameOptions(gameTemplate);
        updateGameSpecificContent(gameTemplate);
    });

    $galleryModal.on('show.bs.modal', (e) => {
        $galleryModal.addClass('loading');
        $modalContent.load(url, (e) => {
            $galleryModal.removeClass('loading');
        });
    });

    $galleryModal.on('hidden.bs.modal', (e) => {
        $modalContent.empty();
    });

    $(document).on('click', '.image-picker', (e) => {
        openImagePicker(e);
    });

    $(document).on('click', '#gallery-modal .card-img:not(.infos) .card-body', (e) => {
        pickImage(e);

        let gameTemplate = getGameTemplate();

        if (gameTemplate === 'memo') {
            let $cardsWrapper = $picker.closest('.memo-cards-wrapper');

            // Check if picking a card or a back image.
            if ($cardsWrapper.length) {
                // Check if same or different images.
                if ($picker.closest('[data-different-images="false"]').length) {
                    // Clone image picker.
                    cloneImgPicker();
                } else if ($picker.closest('[data-different-images="true"]').length) {
                    // Check if both images are set and if min. amount is not reached yet.
                    if ($cardsWrapper.find('.image-picker-info').length === 0 && $cardsWrapper.children().length < differentMemoCardsMin) {
                        cloneMemoCardGroup();
                    }
                }
            }
        }

        $galleryModal.modal('hide');
    });

    $(document).on('click', '.remove-img', (e) => {
        let $el = $(e.currentTarget).closest('.image-picker-wrapper');
        let $wrapper = $el.closest('.memo-cards-wrapper');
        removeImage($el);
        updateMemoCardImagePickers($wrapper);
    });

    $(document).on('click', '.remove-card', (e) => {
        let $card = $(e.currentTarget).closest('.group-memo-card-pair');
        let $wrapper = $card.closest('.memo-cards-wrapper');

        $card.remove();
        updateMemoCardIndexes($wrapper);

        if ($wrapper.children().length === 0) {
            cloneMemoCardGroup();
        }
    });

    init();
});